import * as React from "react";
const SvgAddFolder = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.5 7.83342H11.5M9 5.33341V10.3334M9.05229 2.05237L8.94772 1.9478C8.65946 1.65954 8.51534 1.51542 8.34714 1.41235C8.19802 1.32097 8.03545 1.25363 7.86539 1.2128C7.67357 1.16675 7.46975 1.16675 7.0621 1.16675H4.16667C3.23325 1.16675 2.76654 1.16675 2.41002 1.3484C2.09641 1.50819 1.84144 1.76316 1.68166 2.07676C1.5 2.43328 1.5 2.89999 1.5 3.83341V10.1667C1.5 11.1002 1.5 11.5669 1.68166 11.9234C1.84144 12.237 2.09641 12.492 2.41002 12.6518C2.76654 12.8334 3.23325 12.8334 4.16667 12.8334H13.8333C14.7668 12.8334 15.2335 12.8334 15.59 12.6518C15.9036 12.492 16.1586 12.237 16.3183 11.9234C16.5 11.5669 16.5 11.1002 16.5 10.1667V5.50008C16.5 4.56666 16.5 4.09995 16.3183 3.74343C16.1586 3.42983 15.9036 3.17486 15.59 3.01507C15.2335 2.83341 14.7668 2.83341 13.8333 2.83341H10.9379C10.5303 2.83341 10.3264 2.83341 10.1346 2.78736C9.96455 2.74654 9.80198 2.6792 9.65286 2.58782C9.48466 2.48475 9.34054 2.34062 9.05229 2.05237Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgAddFolder;
